import React from "react";
import { Input } from "@fluentui/react-components";

const SearchInput = ({ value, onChange, className }) => {
  return (
    <Input className={className} placeholder="Search..." value={value} onChange={(_, data) => onChange(data.value)} />
  );
};

export default SearchInput;
